// get single payment method

import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from '../constants';
import { PaymentMethod } from './types';

export default (makeCall: MakeCall) => (uuid: string) =>
  makeCall<PaymentMethod>('GET', `${APIV2_URL}/payment/method/${uuid}`);
